import { Heading, Text, Container, Box, Flex } from '@chakra-ui/react'
import { ProtectedPage } from '@/shared/components/ProtectedPage'
import { ProtectedRouteConfig } from '@/shared/types/routes'

type Props = {
    routeConfig: ProtectedRouteConfig
    headerText: string
    subHeaderText?: string
    headerActions?: React.ReactNode
    children: React.ReactNode
}
export default function PageContainer({
    routeConfig,
    headerText,
    subHeaderText,
    headerActions,
    children
}: Props) {
    return (
        <ProtectedPage routeConfig={routeConfig}>
            <Box
                minH={['container.sm', 'container.md']}
                borderRadius={4}
                bg={'white'}
                mx={'auto'}
                py={5}
                px={{ base: 2, md: 17 }}
            >
                <Flex
                    alignItems="center"
                    gap="2"
                    flexWrap="wrap"
                    justifyContent={'space-between'}
                >
                    <Box p="2">
                        <Heading size="lg" my={2}>
                            {headerText}
                        </Heading>
                        {subHeaderText && <Text color={'gray.600'}>{subHeaderText}</Text>}
                    </Box>
                    {headerActions}
                </Flex>
                <Container maxW={'full'} my={12}>
                    {children}
                </Container>
            </Box>
        </ProtectedPage>
    )
}
